
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/consumer_protection_policy",
      function () {
        return require("private-next-pages/[lng]/consumer_protection_policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/consumer_protection_policy"])
      });
    }
  